import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';

// Import Setting Service and User, Credential Model
import { User, Credential } from '../';
import { ApiService, SettingService } from '../../core/services';

@Injectable()
export class SessionService {
    private sessionUrl = '/session';
    private cafeteriaUrl = '/caterer-service/';
    private apiUrl = '';

    constructor (
        private settingService: SettingService,
        private apiService: ApiService
    ) {
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    /** 
     * Get Session from API
     * @params: none
     * @return: status 200 - User observable object if session is provied succesfully.
     *          status 401 - Unauthorized if user credentials are invalid.
     * */ 
    getSession (): Observable<User> {
        const requestUrl = this.apiUrl + this.sessionUrl;
        
        // Call Get Method from Api Service
        return this.apiService.get<User>(requestUrl);
    }

    /** 
     * Get Session from API
     * @params: User Observable Object
     * @return: status 200 - User observable object if session is created.
     *          status 401 - Unauthorized if no session is found.
     * */ 
    postSession (credential: Credential): Observable<User> {
        const requestUrl = this.apiUrl + this.sessionUrl;
        const body = JSON.stringify({ 
                        'role': credential.role,
                        'email': credential.email,
                        'password': credential.password
                     });
        
        // Call Get Method from Api Service
        return this.apiService.post<User>(requestUrl, body);
    }

    deleteSession (): Observable<any> {
        const requestUrl = this.apiUrl + this.sessionUrl;

        return this.apiService.delete(requestUrl);
    }

    getCafeteriaUrl(){
        const requestUrl = this.apiUrl + this.cafeteriaUrl + 'daisyLink';
        
        // Call Get Method from Api Service
        return this.apiService.get<any>(requestUrl);
    }

    getSessionDaisy(){
        const requestUrl = this.apiUrl + this.cafeteriaUrl + 'getTokenByCookie';
        
        // Call Get Method from Api Service
        return this.apiService.get<any>(requestUrl);
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/user/services/SessionService.ts